

























import { Component, Prop, Vue } from "vue-property-decorator"
import { mapGetters } from "vuex"

@Component({
    ...mapGetters(["account"])
})
export default class SetPassword extends Vue {
    @Prop({ type: Object })
    userData!: Account;

    origin: string | null = null;
    originTip: boolean = false;
    dup: string | null = null;
    dupTip: boolean = false;
    newPwd: string | null = null;
    newTip: boolean = false;

    level: number = this.$store.state.account.level;

    resetForm() {
        this.origin = null;
        this.originTip = false;
        this.dup = null;
        this.dupTip = false;
        this.newPwd = null;
        this.newTip = false;
    }

    showOriginTip() {
        if (this.origin == null || this.origin == "") {
            this.originTip = true;
        } else {
            this.originTip = false;
        }
    }

    showDupTip() {
        if (this.dup != this.newPwd && this.level > 2) {
            this.dupTip = true;
        } else {
            this.dupTip = false;
        }
    }

    showNewTip() {
        if (this.newPwd == null || this.newPwd == "") {
            this.newTip = true;
        } else {
            this.newTip = false;
        }
    }

    cancel() {
        this.$emit("close", false);
    }

    confirm() {
        let level = this.level;
        if (level <= 2) {
            if (this.newPwd == null || this.newPwd == "") {
                this.newTip = true;
            } else {
                this.successCB()
            }
        } else {
            if (this.origin == null || this.origin == "") {
                this.originTip = true;
            } else if (this.newPwd == null || this.newPwd == "") {
                this.newTip = true;
            } else if (this.dup == null || this.dup == "") {
                this.dupTip = true;
            } else if (this.dup != this.newPwd) {
                this.dupTip = true;
            } else {
                this.successCB()
            }
        }
    }

    successCB() {
        let level = this.level;
        Vue.axios.post("accounts/savepassword", {
            id: this.userData.id,
            hashPassword: level <= 2 ? this.newPwd : this.dup,
            originalPassword: level > 2 ? this.origin : null,
            level: level
        }).then((response:any) => {
            this.$message({
                type: "success",
                message: "密码修改成功！",
                duration: 1200
            })
            this.$emit("close", true);
        })
    }
}
